import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { MsalAngularService } from '@services/msal-angular.service';

@Injectable({
    providedIn: 'root',
})
export class AuthService {
    private lastRouteKey = 'lastRoute';

    constructor(private router: Router, private msalAngularService: MsalAngularService) {}

    private storeLastRoute(route: string) {
        localStorage.setItem(this.lastRouteKey, route);
    }

    private getAndClearLastRoute(): string | null {
        const route = localStorage.getItem(this.lastRouteKey);
        localStorage.removeItem(this.lastRouteKey);
        return route;
    }

    navigateToStoredRoute() {
        const route = this.getAndClearLastRoute() ?? this.router.url;
        if (route) {
            if (route.includes('login-not-possible')) {
                this.router.navigateByUrl('/home');
            } else {
                this.router.navigateByUrl(route);
            }
        }
    }

    login() {
        this.storeLastRoute(this.router.url);
        // this.oidcSecurityService.authorize();
        this.msalAngularService.login();
    }
}
